'use strict';

/**
 *
 * @name: coverSeriesExtended
 *
 */

import DirectiveTemplate from './nn-cover-seasons-extended.directive.html';
import './nn-cover-seasons-extended.directive.scss';

function CoverSeasonsExtendedDirective(
  apiSeasonsService,
  transObject,
  $rootScope,
  $state,
  $stateParams,
  $location,
  $compile,
  $timeout,
  angularticsService,
  seasonsAnalytics
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    transclude: true,
    scope: {
      content: '&',
      loaded: '=',
      mainSeriesPlayer: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      scope.item = scope.content();
      scope.seasonsAnalytics = seasonsAnalytics;
      scope.item.title = scope.item.title || 'SEASONS';
      scope.swiperOptions = {
        spaceBetween: 20
      }

      /**
       *
       * @PUBLIC
       *
       */

      scope.onAnalyticsClick = post => {
        $rootScope.analytics.videoAM('single series', scope.item.title, post)
      }

      /**
       *
       * @PRIVATE
       *
       */

      function translateData() {

        if (!scope.item.seasons[0].translations.hasOwnProperty($rootScope.lang)) {
          transObject.translate(scope.item.seasons[0]);

          if (scope.item.seasons[0].posts && scope.item.seasons[0].posts.length) {

            scope.item.seasons[0].posts.forEach(function(post) {

              transObject.translate(post);
              transObject.getDuration(post);
              transObject.setBookmark(post);
              transObject.calendarDate(post);
              transObject.trueSlug(post);

              if (post.tags && post.tags.length) {

                post.tags.forEach(function(tag) {

                  transObject.translate(tag);
                });
              }

              transObject.myAss(post);
            });
          }
        }
      }

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      function loadData() {

        apiSeasonsService
          .getSeasonsById(scope.item.seasons[0].id, false)
          .then(function(result) {

            result.data.posts.forEach(function(item) {
              transObject.translate(item);
              transObject.getDuration(item);
              transObject.setBookmark(item);
              transObject.calendarDate(item);
              transObject.trueSlug(item);
            });

            scope.item.seasons[0].posts = result.data.posts;
            scope.loaded = true;
          });
      }

      if (!scope.item.jsonData.sources || !scope.item.jsonData.sources[0] || !scope.item.jsonData.sources[0].seasonId) {

        return terminate();
      }


      /**
       *
       * @INIT
       *
       */

      translateData();
      loadData();

      scope.$on('ngRepeatFinished', () => {
        if (scope.baseSwiper) {
          scope.baseSwiper.setUpdate()
        }
      })
    }
  };
}

export default CoverSeasonsExtendedDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/seasons/nn-cover-seasons-extended/nn-cover-seasons-extended.directive.js